export default{
	state:{
		show_qrcode:false,
		show_src:false,
		props:"",
	},
	mutations:{

		get_src(state,props){
			state.props = props;
			state.show_src = true;
		},
		get_qrcode(state,props){
			state.props = props;
			state.show_qrcode = true;
		},
		change_qrcode_show(state){
			state.show_qrcode = !state.show_qrcode
		},
		change_src_show(state){
			state.show_src = !state.show_src
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/qrcode.js